import { required, numeric, integer, minValue, helpers } from '@vuelidate/validators';
import i18n from "@/plugins/i18n";

export default function (formState) {
  return {
    item: {
      inventory_id: {
        required: helpers.withMessage(i18n.global.t('Please select an ingredient.'), required)
      },
      unit_id: {
        required: helpers.withMessage(i18n.global.t('Please select a unit.'), required),
        integer: helpers.withMessage(i18n.global.t('Please enter a valid number.'), integer)
      },
      quantity: {
        required: helpers.withMessage(i18n.global.t('Please enter a quantity.'), required),
        numeric: helpers.withMessage(i18n.global.t('Please enter a valid number for the quantity.'), numeric),
        minValue: helpers.withMessage(i18n.global.t('Quantity must be greater than 0.'), minValue(0.0001))
      }
    }
  }
};
